import { errorMessage, useMonitoringMetrics, useMonitoringRuntime } from "../api";
import { ErrorBlock, LoadingBlock } from "../components/primitives";
import { DependenciesCard } from "./backend/dependencies-section";
import { InstancesCard, IntegrationsCard, MonitoringHealthCard } from "./backend/monitoring-health";
import { ModelsCard, SettingsCard } from "./backend/models-settings";
import { EventLoopCard, ProcessCard } from "./backend/process-section";
import { ResourcesCard } from "./backend/resources-section";

/**
 * Backend: the process the admin talks to (identity, event loop, resources, models, settings, the
 * monitoring's own health and integrations), its dependencies and the instances that wrote metrics.
 * Runtime data is this instance's; the window charts follow the board's window and scope.
 */
export function BackendTab() {
  const runtime = useMonitoringRuntime();
  const metrics = useMonitoringMetrics();
  const data = runtime.data;
  const updatedAt = runtime.dataUpdatedAt || Date.now();

  return (
    <div className="flex min-w-0 flex-col gap-4">
      {runtime.isError && (
        <ErrorBlock message={errorMessage(runtime.error)} onRetry={() => void runtime.refetch()} />
      )}
      {metrics.isError && (
        <ErrorBlock message={errorMessage(metrics.error)} onRetry={() => void metrics.refetch()} />
      )}

      {runtime.isPending ? (
        <>
          <div className="grid grid-cols-1 gap-4 2xl:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
            <LoadingBlock height={260} />
            <LoadingBlock height={260} />
          </div>
          <LoadingBlock height={420} />
        </>
      ) : data ? (
        <>
          <div className="grid grid-cols-1 gap-4 2xl:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
            <ProcessCard process={data.process} />
            <EventLoopCard lag={data.lag} metrics={metrics.data} />
          </div>
          <ResourcesCard runtime={data} metrics={metrics.data} />
        </>
      ) : null}

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <DependenciesCard />
        {data ? <ModelsCard models={data.models} /> : runtime.isPending ? <LoadingBlock height={200} /> : null}
      </div>

      {data && (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <MonitoringHealthCard runtime={data} updatedAt={updatedAt} />
          <IntegrationsCard integrations={data.integrations} />
        </div>
      )}

      <InstancesCard />

      {data && <SettingsCard settings={data.settings} />}
    </div>
  );
}
